import React, { useEffect } from "react";
import Header from "../../components/Header";
import { Link, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { refActions } from "../../store/refSlice";
import { popupActions } from "../../store/popupSlice";
import UserHome from "./UserHome";
import MainCashBack from "./MainCashBack";
import Favorites from "./Favorites";
import Social from "./Social";
import Utilitys from "./Utilitys";
import AboutUs from "./AboutUs";
import FooterV2 from "../../components/FooterV2";
import PostSlider from "./PostSlider";
import Modal from "../../components/Modal";
import GoToGuide from "../../components/Modal/popup/GoToGuide";
import StatsBar from "./StatsBar";
import bannerApi from "../../api/bannerApi";

function Home() {
    const { guidePopup } = useSelector((state) => state.popup);
    // Banner lọc theo đối tượng ở backend (user mới / chưa có đơn…) → phải gọi lại
    // khi trạng thái đăng nhập đổi, nếu không khách vừa login vẫn thấy banner của khách vãng lai.
    const { isLogined } = useSelector((state) => state.auth);
    const dispatch = useDispatch();
    const [params] = useSearchParams();

    useEffect(() => {
        if (!params.get("ref")) return;
        document.cookie = `ref=${params.get("ref")}`;
        dispatch(refActions.setRef(params.get("ref")));
    }, [params, dispatch]);

    // Fetch banner popup từ API
    useEffect(() => {
        const fetchBanner = async () => {
            try {
                const { data } = await bannerApi.getActiveBanners();
                const banners = data.data || [];
                if (banners.length === 0) return;

                // Lấy banner ưu tiên cao nhất (đã sort từ API)
                const banner = banners[0];
                const storageKey = `banner_popup_${banner.bannerId}`;

                // Kiểm tra showOncePerDay
                if (banner.showOncePerDay) {
                    const today = new Date().toDateString();
                    const lastShown = localStorage.getItem(storageKey);
                    if (lastShown === today) return;
                    localStorage.setItem(storageKey, today);
                }

                dispatch(popupActions.setBannerData(banner));
                // Hiển thị sau 1.5 giây
                setTimeout(() => {
                    dispatch(popupActions.setGuide(true));
                }, 1500);
            } catch (error) {
                console.error("Fetch banner error:", error);
            }
        };
        fetchBanner();
    }, [dispatch, isLogined]);

    return (
        <div className="h-dvh flex flex-col">
            <Header />
            <div className="flex flex-col justify-between h-full md:w-[768px] lg:w-[1024px] md:mx-auto ">
                <div className="pt-16 flex flex-col gap-2 mt-2">
                    <StatsBar />
                    <UserHome />
                    <MainCashBack />
                    <Favorites />
                    <Utilitys />
                    <Social />
                    <Link to={"https://longhousee-shopeexu.vercel.app/"} target="_blank" className="p-2 bg-surface">
                        <div className="bg-brand-crimson p-1 rounded-lg">
                            <img src="img/ui/shopee_spinner.png" alt="spinner" className="w-full" />
                        </div>
                    </Link>
                    <PostSlider />
                    <AboutUs />
                    <div className="pb-20"></div>
                    <FooterV2 />
                </div>
            </div>
            <Modal
                isOpen={guidePopup}
                onClose={() => dispatch(popupActions.closeGuide())}
            >
                <GoToGuide />
            </Modal>
        </div>
    );
}

export default Home;
